module.exports = __webpack_public_path__ + "img/6.f2a17f68.jpg";